export default "__VITE_ASSET__286b7180__"